exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".footer {\n    position: fixed;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    text-align: center;\n\n    width:100%;\n    height:55px;   /* Height of the footer */\n}", ""]);

// exports
